import LTR from "@brand-icons/ploom/arrow-backward/arrow-backward-ltr.svg";
import RTL from "@brand-icons/ploom/arrow-backward/arrow-backward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ArrowBackwardIcon = iconFactory("ArrowBackwardIcon", LTR, RTL);
